import { Header, ScrollContainer } from "best-common-react";
import React from "react";
import MyPurchaseOppTable from "../../components/purchaseOpportunity/MyPurchaseOppTable";

const MyPurchaseOpportunityRequest: React.FC = () => {
  return (
    <div>
      <Header sticky title="My Purchase Opportunities" />
      <ScrollContainer className="bcr-p-2">
        <MyPurchaseOppTable />
      </ScrollContainer>
    </div>
  );
};

export default MyPurchaseOpportunityRequest;
